/** Keep documentType keys in sync with API `transcriptDocumentUploadRequirements.js`. */
export const TRANSCRIPT_DOCUMENT_TYPE_OPTIONS = [
  { documentType: 'erc_substantiation', label: 'ERC Substantiation Document' },
  { documentType: 'form_941', label: 'Form 941' },
  { documentType: 'form_941x', label: 'Form 941-X' },
  {
    documentType: 'form_941x_proof',
    label: 'Form 941-X Proof of Submission (e.g., Certified Mail receipt, tracking confirmation, or e-file confirmation)'
  },
  {
    documentType: 'form_w2',
    label: 'Form W-2 (for all employees included in the ERC calculation)'
  },
  { documentType: 'form_w3', label: 'Form W-3' },
  { documentType: 'letter_6042c', label: 'Letter 6042C' },
  { documentType: 'proof_of_authority', label: 'Proof of Authority' }
]

export function labelForTranscriptDocumentType(documentType) {
  const row = TRANSCRIPT_DOCUMENT_TYPE_OPTIONS.find(o => o.documentType === documentType)
  return row?.label || documentType
}
